let googleApi;
let resolveGMapsFn;
let initialized = false;

const initializationPromise = new Promise((resolve) => {
    resolveGMapsFn = resolve;
});

/**
 * @description callback fires once google maps api loaded
 */
// @ts-ignore
window.googleMapsApiCallback = () => {
    // @ts-ignore
    googleApi = window.google;

    resolveGMapsFn();
};

/**
 * @description Return mapping config for provided country
 * @param {string} country - Mapping config country
 * @returns {object} Mapping config
 */
function getAddressFieldsMappingConfig(country) {
    const config = {
        address1: {
            serviceObjectTypes: ['street_number', 'route'],
            serviceObjectProperty: 'long_name'
        },
        city: {
            serviceObjectTypes: [['locality', 'postal_town']],
            serviceObjectProperty: 'long_name'
        },
        stateCode: {
            serviceObjectTypes: ['administrative_area_level_1'],
            serviceObjectProperty: 'short_name'
        },
        postalCode: {
            serviceObjectTypes: ['postal_code'],
            serviceObjectProperty: 'long_name'
        }
    };
    switch (country) {
        case 'GB':
            config.stateCode.serviceObjectTypes = ['administrative_area_level_2'];
            break;
        default:
            break;
    }

    return config;
}

/**
 * @description Return address component by provided type
 * @param {Array} addressComponents - API address components
 * @param {string} type - Target component type
 * @returns {object|undefined} Address component
 */
function getAddressComponentByType(addressComponents, type) {
    return addressComponents.find((addressComponent) => {
        return addressComponent.types.indexOf(type) > -1;
    });
}

/**
 * @description Return address component by provided type
 * @param {object} addressComponents - API address components
 * @param {object} fieldConfig - Configuration object for current field
 * @returns {string} Address field
 */
function getAddressField(addressComponents, fieldConfig) {
    const typesForMerge = fieldConfig.serviceObjectTypes;
    const aimProperty = fieldConfig.serviceObjectProperty;
    const targetAddressProperties = [];
    let addressComponent;

    typesForMerge.forEach((mergeType) => {
        if (Array.isArray(mergeType)) {
            for (let i = 0, l = mergeType.length; i < l; i++) {
                addressComponent = getAddressComponentByType(addressComponents, mergeType[i]);
                if (addressComponent && addressComponent[aimProperty]) {
                    break;
                }
            }
        } else {
            addressComponent = getAddressComponentByType(addressComponents, mergeType);
        }

        if (addressComponent && addressComponent[aimProperty]) {
            targetAddressProperties.push(addressComponent[aimProperty]);
        }
    });
    return targetAddressProperties.join(' ');
}

/**
 * @description Loads google maps API
 * @param {string} apiKey - api key
 * @returns {Promise} result
 */
export function initGoogleMapsApi(apiKey) {
    if (!initialized) {
        const url = new URL('https://maps.googleapis.com/maps/api/js');

        url.searchParams.append('key', apiKey);
        url.searchParams.append('libraries', 'places');
        url.searchParams.append('callback', 'googleMapsApiCallback');

        const script = document.createElement('script');
        script.src = url.toString();
        script.async = true;
        script.type = 'text/javascript';

        document.body.appendChild(script);

        initialized = true;
    }

    return initializationPromise;
}

/**
 * @description Inits google autocomplete for the field
 * @param {HTMLInputElement} field - input field
 * @param {string} countryCode - country code to restrict search results
 * @returns {Promise} result
 */
export function initGoogleAutocomplete(field, countryCode) {
    return Promise.resolve(new googleApi.maps.places.Autocomplete(
        field, {
            componentRestrictions: {
                country: countryCode
            }
        }
    ));
}

/**
 * @description Returns parsed address object
 * @param {Array} addressComponents - Array with google address components
 * @param {string} country - Components country
 * @returns {object} result
 */
export function parseAddress(addressComponents, country) {
    const mappingConfig = getAddressFieldsMappingConfig(country);
    const address = Object.keys(mappingConfig).reduce((addressObject, field) => {
        addressObject[field] = getAddressField(addressComponents, mappingConfig[field]);

        return addressObject;
    }, {});

    return Promise.resolve(address);
}
